import api from '@edu-fe/api'

const module = {
  name: 'course',

  freeCourse (category = '', pageNo = 1, pageSize = 3) {
    return api.create(`/freevideo/list?category=${category}&pageNo=${pageNo}&pageSize=${pageSize}`)
  },

  get (categoryId, pageNo = 1, pageSize = 9) {
    if (!categoryId) {
      return console.warn('[API Request]: Param "categoryId" is required!')
    }

    return api.create(`/category/courses?categoryId=${categoryId}&pageNo=${pageNo}&pageSize=${pageSize}&client=2`)
  },

  operationCourse (type = 2, pageNo = 1, pageSize = 5, client = 2) {
    return api.create(`/operation/page?pageNo=${pageNo}&pageSize=${pageSize}&type=${type}&client=${client}`)
  },

  // chapterId 获取 courseId
  getCourseId: api.create('/course/id/chapter'),

  // 通过 courseId 获取 type
  getType: api.create('/course/media/type'),

  // 课程购买挽留
  getRetain: courseId => api.create(`/course/buy/persuade?courseId=${courseId}`)
}

export default module
